import InviteTabContent from './InvitesTabContent';

function Invite() {
  return <InviteTabContent />;
}

export default Invite;
